// eslint-disable-next-line no-undef
__webpack_nonce__ = window.__webpack_nonce__;

import { createApp } from 'vue';
import VueScrollTo from 'vue-scrollto';
import VueSmartWidget from 'vue-smart-widget';
import VueSnip from 'vue-snip';
import datepicker from 'vue3-datepicker';
import { PerfectScrollbarPlugin } from 'vue3-perfect-scrollbar';
import Select2 from 'vue3-select2-component';
// https://floating-vue.starpad.dev/
import FloatingVue from 'floating-vue';
import { Tooltip, vTooltip } from 'floating-vue';
import { GDialog } from 'gitart-vue-dialog';
import VCalendar from 'v-calendar';
import 'jquery/dist/jquery.min';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'bootstrap/dist/css/bootstrap.css';
import 'select2/dist/css/select2.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'floating-vue/dist/style.css';
import 'select2/dist/js/i18n/ru';
import 'vue-smart-widget/lib/style.css';
import 'gitart-vue-dialog/dist/style.css';
import 'v-calendar/dist/style.css';
import 'vue3-perfect-scrollbar/dist/style.css';

import { configAxios } from '@/common/axios';
import EmptyListMessage from '@/common/components/EmptyListMessage.vue';
import Pagination from '@/common/components/Pagination.vue';
import directiveClickOutside from '@/common/directives/click-outside.js';
import { permission } from '@/common/directives/permission.js';

import App from './App.vue';
import { getRuFormattedDate } from './common/utils/dates';
import router from './router';
import store from './store';
import tableArrow from '/plugins/table-arrow/index';
import tableArrowNew from '/plugins/table-arrow-new/index';

import './assets/theme/default/style.scss';

// Блиц не работает с хешами, поэтому после возвращения с Блица подставляем хеш
const searchParams = new URLSearchParams(window.location.search);
if (searchParams.has('code') || searchParams.has('error')) {
  const callbackQuery = searchParams.toString();
  window.history.replaceState(null, '', '/');
  window.location.hash = `#/auth/callback?${callbackQuery}`;
}

configAxios();
const app = createApp(App).use(store).use(router);
app.use(VueSmartWidget);
app.use(VCalendar, {});
app.use(VueScrollTo);
//стрелочки на таблицах, {speed: 45, selector: '.table-container'}
// можно добавить опции скорость прокрутки и контейнер(стоит по умолчанию)
app.use(tableArrow, { speed: 45, selector: '.js-table-arrow' });
//стрелочки на таблицах, {speed: 45, selector: '.table-container-new'}
// можно добавить опции скорость прокрутки и контейнер(стоит по умолчанию)
app.use(tableArrowNew);
app.config.globalProperties.$momentFormat = getRuFormattedDate;
app.component('GDialog', GDialog);
app.component('EmptyListMessage', EmptyListMessage);
app.component('Pagination', Pagination);
app.component('Select2', Select2);
app.component('datepicker', datepicker);
app.component('VTooltip', Tooltip);
app.use(VueSnip);
app.use(PerfectScrollbarPlugin);
app.use(FloatingVue);
app.mount('#app');

app.directive('click-outside', directiveClickOutside);
app.directive('tooltip', vTooltip);
app.directive('permission', permission);
